



































































import _ from 'lodash'
import { State } from 'vuex-class'
import { Vue, Component, Prop } from 'vue-property-decorator'
import VueMultiselect from 'vue-multiselect'
import { RootState } from '@/store/types'
import Entry from '@/data/entry-model'

/**
 * Wrapper for the vue-multiselect component
 */
@Component({ components: { VueMultiselect }, name: 'v-select' })
export default class VSelect extends Vue {
    // VueMultiselect props
    @Prop() name: any
    @Prop() options: any
    @Prop() trackBy: any
    @Prop() showLabels: any
    @Prop() value: any
    @Prop() allowEmpty: any
    @Prop() internalSearch: any
    @Prop() placeholder: any
    @Prop() disabled: any
    @Prop() multiple: any
    @Prop() closeOnSelect: any
    @Prop() taggable: any
    @Prop() tagPlaceholder: any

    /**
     * Search term to use in custom search
     */
    searchTerm: string = ''

    // Custom props

    /**
     * Whether the options have icons
     *
     * Requires 'icon' property for each option
     */
    @Prop({ type: Boolean, default: false })
    hasIcons!: boolean

    /**
     * The default icon to show if no icon found for an option
     */
    @Prop({ type: String, default: 'folder' })
    defaultIcon!: string

    /**
     * Whether to show paths or just names
     *
     * Requires 'path' and 'title' properties for each option,
     * if false, each option requires 'name'
     */
    @Prop({ type: Boolean, default: false })
    hasPaths!: boolean

    /**
     * Get results of search
     *
     * Searches the title path of each option if hasPaths is enabled.
     *
     * TODO: fuzzy search
     */
    get filteredOptions(): any[] {
        if (this.hasPaths) {
            return this.options.filter((option: Entry) => (
                option.title.toLowerCase().includes(this.searchTerm) ||
                option.titlePath.filter((name: string) => (
                    name.toLowerCase().includes(this.searchTerm)
                )).length > 0
            ))
        }
        return this.options.filter((option: any) => (
            (option.name || option.title || option).toLowerCase().includes(this.searchTerm)
        ))
    }

    /**
     * Get the icon for the prop
     */
    getIcon(option: any): string {
        return option && option.icon ? option.icon : this.defaultIcon
    }

    /**
     * Update the search term
     */
    updateSearchTerm(value: string): void {
        this.searchTerm = value.toLowerCase()
    }
}
